import shadows from "@mui/material/styles/shadows";
import React, { useEffect, useState } from "react";
import { GetProfileDetails, GetUserModel } from "../../../ApiServices/Profile/ProfileApi";
import { daily_nakshatra_prediction } from "../../../ApiServices/Horoscope/BirthDetailsApi";
import dayjs from "dayjs";
import HoroscopeBannerImg from "../../../assets/images/new/HoroscopeBanner.png";
import Breadcrumbs from "../../Breadcrumb";
import astrology from "../../../assets/images/new/astrology.png";
import panchang from "../../../assets/images/new/panchang.png";
import numerology from "../../../assets/images/new/numerology.png";
import zodiacSign from "../../../assets/images/new/zodiacSign.png";
import Astro from "../../../assets/images/new/services1 (1).jpg";
import Panchang from "../../../assets/images/new/services1 (2).jpg";
import NumerologyImage from "../../../assets/images/new/services1 (3).jpg";
import Prediction from "../../../assets/images/new/services1 (3).jpg";
import astone from "../../../assets/images/new/solar-bg.png";
import asto from "../../../assets/images/new/solar-bgo.png";
import astt from "../../../assets/images/new/solar-bgt.png";
import Asthree from "../../../assets/images/new/solar-bgthree.png";
import Asfoure from "../../../assets/images/new/solar-bgfoure.png";
import Asfive from "../../../assets/images/new/solar-bgfive.png";
import batuk from "../../../assets/images/new/fav-removebg-preview.png";
import { useLocation, useNavigate } from "react-router-dom";
import ErrorMassagePupUp from "../../ErrorMassagePupUp";
const DailyPrediction = () => {
  const [animate, setAnimate] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [dailyPredictionList, setDailyPredictionObj] = useState([]);
  const [showErrorModal, setShowErrorModal] = useState(false)
  const [customErrorMassage, setCustomErrorMassage] = useState("")

  useEffect(() => {
    GetUserModelData();
    setTimeout(() => {
      setAnimate(true);
    }, 300); // Delay animation to make it smoother
  }, []);

  const GetUserModelData = async () => {
    // setLoader(true);

    const userKeyID = localStorage.getItem("userKeyID");
    try {
      const response = await GetProfileDetails(userKeyID);
      if (response?.statusCode === 200) {
        // setLoader(false);
        const ModelData = response?.responseData?.data || []; // Assuming the data is an array and we need the first item

        const dob = new Date(ModelData?.dob);

        const year = dob.getFullYear();
        const month = dob.getMonth() + 1; // Months are zero-based (0 = January)
        const day = dob.getDate();

        const [hours, minutes] = ModelData?.tob.split(":");
        const apiParam = {
          day: day,
          month: month,
          year: year,
          hour: hours,
          min: minutes,
          lat: 25.7464,
          lon: 25.7464,
          tzone: 5.5,
        };
        await GetDailyPredictionData(
          apiParam,
          dayjs(ModelData?.dob).format("DD/MM/YYYY")
        );
      } else {
        // setLoader(false);

        console.error(
          "Error fetching data: ",
          response?.data?.data?.statusCode
        );
      }
    } catch (error) {
      // setLoader(false);

      console.error("Error", error);
    }
  };
  const GetDailyPredictionData = async (apiParam, birthDate) => {
    try {
      const response = await daily_nakshatra_prediction(apiParam);
      if (response !== null && response !== undefined) {
        // setLoader(false);
        setDailyPredictionObj((prev) => ({
          ...prev,
          Health: response?.prediction?.health,
          Emotion: response?.prediction?.emotions,
          Profession: response?.prediction?.profession,
          Luck: response?.prediction?.luck,
          Personal_life: response?.prediction?.personal_life,
          Travel: response?.prediction?.travel,
        }));
      } else {
        // setLoader(false);

        console.error("Error fetching data: ", response);
      }
    } catch (error) {
      // setLoader(false);
      setCustomErrorMassage(error?.response?.data?.msg)
      setShowErrorModal(true)
      console.error("Error", error);
    }
  };

  const HandleCloseModal = () => {
    setShowErrorModal(false)
    navigate("/")
  }
  return (
    <>
      <section className="feature-four">
        <div className="section-title text-center" style={{ marginBottom: "30px" }}>
          <h6 className="sec-title__tagline bw-split-in-center flex justify-center items-center gap-2">
            <img className="tagline-img" src={batuk} alt="batuk img" />
            Decode Your Destiny
          </h6>

          <h3 className="sec-title__title bw-split-in-left ">
            Numerology and Your Life Path
          </h3>
        </div>

        <div className="container">
          <div className="row gutter-y-30">
            {/* Feature Item 1 */}
            <div
              className="col-lg-4 col-md-6 wow fadeInUp"
              data-wow-delay="00ms"
            >
              <div
                className="feature-four__item"
                style={{ "--accent-color": "#ffa415" }}
              >
                <div
                  className="feature-four__item__bg"
                  style={{ backgroundImage: `url(${astone})` }}
                ></div>
                <div className="feature-four__item__content">
                  <div className="feature-four__item__number"></div>
                  <h3 className="feature-four__item__title">Health</h3>
                  <p className="feature-four__item__text">
                    {dailyPredictionList?.Health}
                  </p>
                </div>
              </div>
            </div>

            {/* Feature Item 2 */}
            <div
              className="col-lg-4 col-md-6 wow fadeInUp"
              data-wow-delay="100ms"
            >
              <div
                className="feature-four__item"
                style={{ "--accent-color": "#fc5528" }}
              >
                <div
                  className="feature-four__item__bg"
                  style={{ backgroundImage: `url(${asto})` }}
                ></div>
                <div className="feature-four__item__content">
                  <div className="feature-four__item__number"></div>
                  <h3 className="feature-four__item__title">Emotion</h3>
                  <p className="feature-four__item__text">
                    {dailyPredictionList?.Emotion}
                  </p>
                </div>
              </div>
            </div>

            {/* Feature Item 3 */}
            <div
              className="col-lg-4 col-md-6 wow fadeInUp"
              data-wow-delay="200ms"
            >
              <div
                className="feature-four__item"
                style={{ "--accent-color": "#8139e7" }}
              >
                <div
                  className="feature-four__item__bg"
                  style={{ backgroundImage: `url(${astt})` }}
                ></div>
                <div className="feature-four__item__content">
                  <div className="feature-four__item__number"></div>
                  <h3 className="feature-four__item__title">Profession</h3>
                  <p className="feature-four__item__text">
                    {dailyPredictionList?.Profession}
                  </p>
                </div>
              </div>
            </div>
            <div
              className="col-lg-4 col-md-6 wow fadeInUp"
              data-wow-delay="200ms"
            >
              <div
                className="feature-four__item"
                style={{ "--accent-color": "#8139e7" }}
              >
                <div
                  className="feature-four__item__bg"
                  style={{ backgroundImage: `url(${Asthree})` }}
                ></div>
                <div className="feature-four__item__content">
                  <div className="feature-four__item__number"></div>
                  <h3 className="feature-four__item__title">Luck</h3>
                  <p className="feature-four__item__text">
                    {dailyPredictionList?.Luck}
                  </p>
                </div>
              </div>
            </div>
            <div
              className="col-lg-4 col-md-6 wow fadeInUp"
              data-wow-delay="200ms"
            >
              <div
                className="feature-four__item"
                style={{ "--accent-color": "#8139e7" }}
              >
                <div
                  className="feature-four__item__bg"
                  style={{ backgroundImage: `url(${Asfoure})` }}
                ></div>
                <div className="feature-four__item__content">
                  <div className="feature-four__item__number"></div>
                  <h3 className="feature-four__item__title">Personal_life</h3>
                  <p className="feature-four__item__text">
                    {dailyPredictionList?.Personal_life}
                  </p>
                </div>
              </div>
            </div>
            <div
              className="col-lg-4 col-md-6 wow fadeInUp"
              data-wow-delay="200ms"
            >
              <div
                className="feature-four__item"
                style={{ "--accent-color": "#8139e7" }}
              >
                <div
                  className="feature-four__item__bg"
                  style={{ backgroundImage: `url(${Asfive})` }}
                ></div>
                <div className="feature-four__item__content">
                  <div className="feature-four__item__number"></div>
                  <h3 className="feature-four__item__title">Travel</h3>
                  <p className="feature-four__item__text">
                    {dailyPredictionList?.Travel}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ErrorMassagePupUp show={showErrorModal} onHide={() => HandleCloseModal()} Massage={customErrorMassage} />
    </>
  );
};

export default DailyPrediction;
